import React, {useEffect, useState} from 'react';
import AppButton from '../../components/app-button';
import AppWrapper from '../../components/app-wrapper';
import Header1 from '../../components/headers/header1';
import Icon from '../../components/icon';
import {Column, Row} from '../../components/layout';
import colors from '../../util/colors';
import {Icons} from '../../util/icons';
import {strings} from '../../util/strings';
import * as fonts from '../../util/fonts';
import ClaimItemsFilter, {
  ClaimItemsFilterProps,
} from '../reimbursements/components/ClaimItemsFilter';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {addToGlobalStyles} from '../../store/actions';
import moment from 'moment';
import {get} from '../../api/api';
import {
  uriGetCategoryList,
  uriGetInsuranceHistoryDetail,
  uriGetInsuranceHistoryList,
  uriStatuses,
} from '../../api/endpoints';
import UtilizationList from './components/UtilizationList';
import ClaimsFilterModal from '../reimbursements/components/ClaimsFilterModal';
import UtilizationDetail from './components/UtilizationDetail';
import {Expense} from '../../components/expenses-detail/ExpensesDetail';
import {sortArrayByParam} from '../../util/utility';
import ModalTemplate from '../../components/modal';

interface UtilizationHistoryProps {
  user: any;
  addToGlobalStyles(value: any): void;
  selectedBu: any;
  labels: typeof strings.pt.insuranceHistory;
  labelsMessages: typeof strings.pt.messages;
}

/*

amountclaimed: 950
amountcopay: 950
amountdeduct: 0
amountdisallow: 0
amountpaid: 0
auditNbr: "92046878151"
catCode: "1"
catName: "Internamento Hospitalar"
clinicName: "Hospital CUF - Infante Santo"
dosFrom: "2020-12-11"
dosThru: "2020-12-11"
estado: "Em análise"
estadoId: "2"
isCat9: 1
providerName: "hospitalcuf infante santo"
rede: "Dentro da Rede"
rsnCode: 999
submittedGroup: "MEMBER"


*/

export interface UtilizationItem {
  amountClaimed: number;
  amountCopay: number;
  amountDeduct: number;
  amountDisallow: number;
  amountPaid: number;
  auditNbr: string;
  catCode: string;
  catName: string;
  clinicName: string;
  dosFrom: string;
  dosThru: string;
  status: string;
  statusId: string;
  isCat9: number;
  providerName: string;
  network: string; // 'dentro da rede' -> consumo, otherwise ('fora de rede') -> reembulso
  rsnCode: number;
  submittedBy: string;
  submittedGroup: string;
}
export interface UtilizationApiResponse {
  data: UtilizationItem[];
  total: number;
  StatusCode: number;
}

function UtilizationHistory({
  labels,
  labelsMessages,
  selectedBu,
}: UtilizationHistoryProps) {
  /*
  State and var declaration
  */
  const [filterShouldRefresh, setFilterShouldRefresh] = useState(false);
  const [selectedItem, setSelectedItem] = useState<UtilizationItem>();
  const [expenses, setExpenses] = useState<Expense[]>([]);
  const [showModal, setShowModal] = useState(false);
  const [showError, setShowError] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [itemSource, setItems] = useState<UtilizationItem[]>();
  const [categories, setCategories] = useState<any[]>([]);
  const [statuses, setStatuses] = useState<any[]>([]);

  const featureName = 'UtilizationHistory';

  const filterParameterChanged = (
    filterParameter: string,
    ParameterValue: string | Date,
  ) => {
    var newFilter = {...filter};
    (newFilter as any)[filterParameter] = ParameterValue;
    setFilter(newFilter);
    setFilterShouldRefresh(true);
  };

  let filterProps: ClaimItemsFilterProps = {
    controlLabels: {
      filterParmOne: labels?.insuranceHistory_filterCoverageLabel,
      filterDateFrom: labels?.insuranceHistory_filterDataLabelShort,
    },
    filterOneOptions: [],
    filterTwoOptions: [],
    filterParmOne: '',
    filterParmTwo: '',
    periodFrom: moment().subtract(6, 'month').toDate(),
    periodTill: moment().toDate(),
    filterParameterChanged: filterParameterChanged,
    filtersHaveChanged: filterShouldRefresh,
  };
  const [filter, setFilter] = useState<ClaimItemsFilterProps>(filterProps);

  /*
  Event handlers / callback functions
  */
  const changedSelectedItem = async (selectedItem: UtilizationItem) => {
    setSelectedItem(selectedItem);
    try {
      const response: any = await get(
        uriGetInsuranceHistoryDetail(
          selectedBu.buId,
          selectedItem.auditNbr,
          selectedItem.isCat9,
          selectedItem.catCode,
        ),
        false,
        0,
        featureName,
      );
      const expenses: Expense[] = response.data.items.map(
        ({
          catName,
          medicalAct,
          dos,
          amountClaimed,
          amountCopay,
          amountDeduct,
          amountDisallow,
          amountPaid,
          code,
          indicator,
          currency,
        }: any) => ({
          catName,
          medicalAct,
          dos,
          amountClaimed,
          amountCopay,
          amountDeduct,
          amountDisallow,
          amountPaid,
          code,
          indicator,
          currency,
        }),
      );
      setExpenses(expenses);
      setShowModal(true);
    } catch (err) {
      setShowError(true);
    }
  };

  const modalWasClosed = () => {
    setFilterShouldRefresh(filter.filtersHaveChanged);
  };

  /* API calls */
  const getListOfUtilization = async () => {
    const filterFromDate =
      filter.periodFrom === undefined
        ? '1900-01-01'
        : moment(filter.periodFrom).format('YYYY-MM-DD');
    const filterToDate =
      filter.periodTill === undefined
        ? '2030-12-31'
        : moment(filter.periodTill).format('YYYY-MM-DD');

    try {
      let result: any = await get(
        uriGetInsuranceHistoryList(
          selectedBu.buId,
          selectedBu.memId,
          filterFromDate,
          filterToDate,
          filter.filterParmOne,
        ),
        false,
        0,
        featureName,
      );
      return result.data.items;
    } catch (e: any) {
      return [];
    }
  };

  const getTheUtilization = () => {
    if (selectedBu) {
      getListOfUtilization().then((res) => {
        setItems(res as UtilizationItem[]);
      });
    }
  };

  useEffect(() => {
    setFilterShouldRefresh(true);
  }, [selectedBu.memId]);

  //Get the filter options for the filter parm 1
  useEffect(() => {
    async function getListOfCategories() {
      if (selectedBu) {
        let result: any = await get(
          uriGetCategoryList(selectedBu.buId, selectedBu.memId),
          false,
          0,
          featureName,
        );
        return result.data.items;
      }
    }

    getListOfCategories().then((res) => {
      let cat = (res as any[]).map((elem) => ({
        value: elem.categoryCode,
        label: elem.categoryName,
      }));

      const orderedCategories = sortArrayByParam(cat, 'label');
      setCategories(orderedCategories);

      let newFilter = {...filter};
      newFilter.filterOneOptions = orderedCategories;
      setFilter(newFilter);
    });
  }, []);

  useEffect(() => {
    if (filterShouldRefresh) {
      getTheUtilization();
      setFilterShouldRefresh(false);
    }
  }, [filterShouldRefresh]);

  useEffect(() => {
    async function getListOfStatuses() {
      return await get(uriStatuses(), false, 0, featureName);
    }

    getListOfStatuses().then((res: any) => {
      const statusOptions = (res.data?.items as any[])
        .filter((elem) => elem.stateName !== 'Default')
        .map((elem) => {
          return {
            value: elem.stateId,
            label: elem.stateName,
            colorCode: elem.color,
            stateId: elem.stateId,
          };
        });

      setStatuses(statusOptions);
    });

    setFilterShouldRefresh(true);
  }, []);

  const errorModal = () => {
    return (
      <ModalTemplate
        type="error"
        show={showError}
        onHide={() => setShowError(false)}
        hideFooter={true}
        cross={true}>
        <p style={{color: colors.alertRed, fontWeight: 'bold'}}>
          {labels?.insuranceHistory_detail_error}
        </p>
      </ModalTemplate>
    );
  };

  const statusId = selectedItem?.statusId?.toLowerCase();

  const {colorCode: color, label: stateDescription} =
    statuses.find((e) => e.value === statusId) || {};

  return (
    <>
      <Column className="reimbursement-history-container ">
        <Row className="reimbursement-history-titlerow reimbursement-history-row">
          <Column className="reimbursement-history-titlecolumn">
            <Header1 style={{...fonts.XL, ...fonts.Bold, color: colors.black}}>
              {labels?.insuranceHistory_title}
            </Header1>
            <label style={{...fonts.M}}>
              {labels?.insuranceHistory_verifyHistory}
            </label>
          </Column>
        </Row>
        <Row className="reimbursement-history-row reimbursement-history-row-filter">
          <ClaimItemsFilter
            restrictDateInterval={true}
            filterParmOne={filter.filterParmOne}
            filterParmTwo={filter.filterParmTwo}
            periodFrom={filter.periodFrom}
            periodTill={filter.periodTill}
            filterParameterChanged={filterParameterChanged}
            filterOneOptions={filter.filterOneOptions}
            filterTwoOptions={[]} // will not be rendered when empty
            controlLabels={{
              filterParmOne: labels?.insuranceHistory_filterCoverageLabel,
              filterDateFrom: labels?.insuranceHistory_filterDataLabelShort,
            }}
            filtersHaveChanged={filter.filtersHaveChanged}></ClaimItemsFilter>
        </Row>
        <Row className="reimbursement-history-row reimbursement-history-declarationslist-row">
          <Column className="reimbursement-history-declarationslist-column">
            <Row>
              <Column className="reimbursement-history-filterbuttoncolumn">
                <AppButton
                  className="reimbursement-history-filterbutton"
                  onClick={() => setShowFilterModal(true)}>
                  <Row className="reimbursement-history-filter-row">
                    <Icon
                      className="reimbursement-history-filter-icon"
                      name={Icons.FILTER}
                      color={colors.white}
                      width="16"
                      height="16"
                      changeViewbox={false}
                      viewBox={'0 -5 26 30'}
                    />
                    {labels?.insuranceHistory_filterButton}
                  </Row>
                </AppButton>
              </Column>
            </Row>
            <UtilizationList
              utilizationItems={
                itemSource && itemSource.length > 0 ? itemSource : []
              }
              selectedItem={changedSelectedItem}
            />
          </Column>
        </Row>
      </Column>
      <ClaimsFilterModal
        setShowFilterModal={setShowFilterModal}
        showFilterModal={showFilterModal}
        filterProps={filter}
        setFilter={setFilter}
        modalWasClosed={modalWasClosed}
      />
      <UtilizationDetail
        selectedItem={selectedItem}
        expenses={expenses}
        color={color}
        stateDescription={stateDescription}
        showModal={showModal}
        setShowModal={setShowModal}
      />
      {errorModal()}
    </>
  );
}

const mapStateToProps = ({selectedBu, strings, user}: any) => ({
  user: user.value,
  selectedBu: selectedBu.value,
  labels: strings.value.pt.insuranceHistory,
  labelsMessages: strings.value.pt.messages,
});

const mapDispatchToProps = (dispatch: any) => ({
  addToGlobalStyles: (value: any) => dispatch(addToGlobalStyles(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(UtilizationHistory),
);
